import styled from 'styled-components';
import { Column } from './Column';
import { Row } from './Row';
import { BoxProps, Box } from '../Box/Box';

interface GridProps extends BoxProps {
  width?: string;
  gutter?: number;
}

export const Grid = styled(Box)<GridProps>`
  ${({ width = '100%', gutter = 16 }) => `
    width: ${width};
    
    ${Column} {
      padding: 0 ${gutter / 2}px;
    }
  
    ${Row} {
      margin-left: ${-(gutter / 2)}px;
      margin-right: ${-(gutter / 2)}px;
    }
  `}
`;
